import React, { useState } from 'react';
import MPOPrintView from './MPOPrintView';
import * as api from '../../api';

export default function MPOPrintButton({ poId }) {
  const [busy, setBusy] = useState(false);
  const [printing, setPrinting] = useState(null);

  const handlePrint = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const po = await api.getMPO(poId);
      setPrinting(po);
      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          window.print();
          setPrinting(null);
          resolve();
        }));
      });
    } catch {
      // silent — table row context has no toast
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handlePrint}
        title="Print PO"
        disabled={busy}
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 30, height: 30, borderRadius: 8,
          cursor: busy ? 'wait' : 'pointer',
          background: 'var(--bg-card)',
          border: '1px solid #0b318b',
          color: '#0b318b',
          transition: 'background 0.15s, color 0.15s',
          opacity: busy ? 0.6 : 1,
        }}
        onMouseEnter={(e) => { if (!busy) { e.currentTarget.style.background = '#0b318b'; e.currentTarget.style.color = '#fff'; } }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bg-card)'; e.currentTarget.style.color = '#0b318b'; }}
      >
        {busy ? (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <circle cx="12" cy="12" r="10" strokeDasharray="40" strokeDashoffset="15"
              style={{ animation: 'spin 0.8s linear infinite', transformOrigin: 'center' }} />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 6 2 18 2 18 9" />
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" />
          </svg>
        )}
      </button>
      {printing && <MPOPrintView po={printing} />}
    </>
  );
}
